import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { useSetState } from "Helpers/Hooks";
import ListPatternsGroup from "./list";
import NewPatternGroup from "./New";
import { useTranslation } from "react-i18next";
import Input from "Components/Input/Input";

export default function PatternsGroup() {
  const { t } = useTranslation();
  const [doSearch, setDoSearch] = useState("CLEARSEARCH");
  const [controls, setControls] = useSetState({
    nameSearch: {
      type: "search",
      value: null,
      row: 2,
      validation: null,
      col: 3,
    },
  });

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
  };

  const onSearch = async (e) => {
    e.preventDefault();
    setDoSearch("DOSEARCH");
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    setControls({ nameSearch: { value: "" } });
    setDoSearch("CLEARSEARCH");
  };

  const onDone = () => {
    setDoSearch("PENDING");
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <Input
          setValue={setValue.bind(this)}
          name="nameSearch"
          value={controls.nameSearch.value ? controls.nameSearch.value : ""}
          placeholder={t("nameSearch")}
          type="search"
          onSearch={onSearch}
          onClearSearch={onClearSearch}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={8}
        className="d-flex justify-content-end mt-1"
      >
        <NewPatternGroup />
      </Grid>
      <Grid item xs={12}>
        <ListPatternsGroup
          nameSearch={controls.nameSearch.value}
          doSearch={doSearch}
          done={onDone}
        />
      </Grid>
    </Grid>
  );
}
